import React from 'react';

export default class PartyHeaders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }
    render() {
        let alliances = this.props.data;

        return (<thead>
            <tr>
                {
                    Object.keys(alliances).length > 0 ? Object.keys(alliances).map((a_key) => {
                        if (alliances[a_key]) {
                            return (<th key={Math.random()}>
                                <div className="flexstart">
                                    {typeof (alliances[a_key].imageUrl) != "undefined" && alliances[a_key].imageUrl ? <img src={alliances[a_key].imageUrl} className="partylogo" /> : ""}
                                    {typeof (alliances[a_key].name) != "undefined" ? <h5 className="party_name">{alliances[a_key].name}</h5> : ""}
                                </div>
                            </th>)
                        } else {
                            return null;
                        }

                    }) : <th><div className="flexstart "><h5 className="party_name">No record found</h5></div></th>
                }



            </tr>
        </thead>)
    }
}
